import React, { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import { useDropzone } from "react-dropzone";
import { Check, X } from "react-feather";

import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { doRequest } from "../utils/helper";
import Sidebar from "../components/Sidebar";
import LazyLoadedImage from "../components/LazyLoadedImage";
import SubscriptionEdit from "./SubscriptionEdit";
import UserBillingHistory from "./UserBillingHistory";

export default function EditProfile() {
  const [userDetails, setUserDetails] = useState({});
  const custImageValue = ""
  const [existImage, setExistImage] = useState(true);
  const [changedImage, setChangedImage] = useState("");
  const [fNameError, setfNameError] = useState(false);
  const [fNameTextError, setfNameTextError] = useState(false);
  const [lnameError, setLNameError] = useState(false);
  const [lNameTextError, setLNameTextError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [gstError, setGstError] = useState(false);
  const [businessNameError, setBusinessNameError] = useState(false);
  const [planDetails, setPlanDetails] = useState([]);
  const [gstValidateText, setGstValidateText] = useState("Validate");
  let { id } = useParams();
  let location = useLocation();
  const [type, setType] = useState(location?.state);

  const [list, setList] = useState([]);

  const getHistory = async () => {
    let data = {
      user_id: id,
    };

    try {
      let response = await doRequest(data, "POST", "order/history");
      if (+response?.resultFlag === 1) {
        setPlanDetails(response?.response?.results);
        setList(response?.response?.results);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    getHistory();
  }, []);

  const gstValidateClickHandler = () => {
    setGstValidateText("Validating");
    setTimeout(() => setGstValidateText("Validate"), 400);
  };

  const imageChangeHandler = (img) => {
    if (!img) return;
    if (!img.type.startsWith("image/")) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setChangedImage(reader.result);

      setExistImage(false);
    };
    reader.readAsDataURL(img);
  };

  const {
    isDragActive,
    isDragAccept,
    isDragReject,
    open,
    getRootProps,
    getInputProps,
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    multiple: false,
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        let file = acceptedFiles[0];
        imageChangeHandler(file);
      }
    },
  });

  const [showInput, setShowInput] = useState(type === "view" ? false : true);

  const [showInputlastname, setShowInputlastname] = useState(
    type === "view" ? false : true
  );

  const [showInputemail, setShowInputemail] = useState(
    type === "view" ? false : true
  );

  const [showInputphone, setShowInputphone] = useState(
    type === "view" ? false : true
  );

  const [showInputbus, setShowInputbus] = useState(
    type === "view" ? false : true
  );

  const [showInputaddress1, setShowInputaddress1] = useState(
    type === "view" ? false : true
  );

  const [showInputaddress2, setShowInputaddress2] = useState(
    type === "view" ? false : true
  );

  const [showInputCity, setShowInputCity] = useState(
    type === "view" ? false : true
  );
  const [showInputState, setShowInputState] = useState(
    type === "view" ? false : true
  );
  const [showInputCountry, setShowInputCountry] = useState(
    type === "view" ? false : true
  );

  useEffect(() => {
    setShowInput(type === "view" ? false : true);
    setShowInputlastname(type === "view" ? false : true);
    setShowInputemail(type === "view" ? false : true);
    setShowInputphone(type === "view" ? false : true);
    setShowInputbus(type === "view" ? false : true);
    setShowInputaddress1(type === "view" ? false : true);
    setShowInputaddress2(type === "view" ? false : true);
    setShowInputCity(type === "view" ? false : true);
    setShowInputState(type === "view" ? false : true);
    setShowInputCountry(type === "view" ? false : true);
  }, [type]);

  let history = useNavigate();

  const getUserDetails = async (id) => {
    try {
      let res = await doRequest("", "GET", `user/list?id=${id}`);
      if (res && +res?.resultFlag === 1) {
        let user = res?.response?.user;
        if (user?.length > 0) {
          setUserDetails(res?.response?.user[0]);
        } else {
          setUserDetails({});
        }
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (id && id !== "") {
      getUserDetails(id);
    }
  }, [id]);

  return (
    <div id="main-container" className="container-fluid main">
      <Sidebar></Sidebar>
      <section className="home">
        <div className="container-fluid">
          <div className="searcmain_pad">{/* <SearchHeader /> */}</div>

          <div className="heading">
            <ul className="userman_breadcrumb">
              <li>
                <Link to="">User management</Link>
              </li>
              <li className="mang_pad">
                <img src={"/assets/images/man_chev.svg"} alt="" />
              </li>

              <li>
                <Link to="">User name</Link>
              </li>
            </ul>
          </div>

          <div className="container">
            <div className="editprofile_wid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card_profile">
                    <div className="editsva_flex">
                      <h4 className="basic_head">Basic Info</h4>
                      {type === "view" ? (
                        <button
                          className="saveeditprofile_btn"
                          onClick={() => {
                            setType("edit");
                            history(`/editprofile/${id}`);
                          }}
                        >
                          Edit Profile
                        </button>
                      ) : (
                        <button
                          className="saveeditprofile_btn"
                          onClick={() => {
                            setType("view");
                            history(`/viewprofile/${id}`);
                          }}
                        >
                          View Profile
                        </button>
                      )}
                    </div>

                    <div className="row row_cen">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5>Photo</h5>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="profile_desc">
                          <h5>A photo helps personalise your account</h5>
                        </div>
                      </div>

                      <div className="col-sm-3 btn_rank">
                        <div className="d-flex align-items-center phone_profile_center pb-2">
                          <Button
                            style={{ color: "" }}
                            onClick={() => open()}
                            className="upload_btn_position badge font-weight-bold"
                          >
                            {custImageValue === "" ? "Add Photo" : "Edit Photo"}
                          </Button>
                          <div className="dropzone rounded-circle imgbox_wid">
                            <div
                              {...getRootProps({
                                className: "dropzone-upload-wrapper",
                              })}
                            >
                              <input {...getInputProps()} />
                              <div className="dropzone-inner-wrapper imgbox_wid2 rounded-circle dropzone-avatar">
                                <div className="avatar-icon-wrapper imgbox_wid3 rounded-circle m-2">
                                  <div>
                                    {isDragAccept && (
                                      <div className="rounded-circle overflow-hidden imgbox_wid4 bg-success text-center font-weight-bold text-white d-flex justify-content-center align-items-center">
                                        <Check className="d-40" />
                                      </div>
                                    )}
                                    {isDragReject && (
                                      <div className="rounded-circle overflow-hidden imgbox_wid5 bg-danger text-center font-weight-bold text-white d-flex justify-content-center align-items-center">
                                        <X className="d-60" />
                                      </div>
                                    )}
                                    {!isDragActive && (
                                      <div className="rounded-circle overflow-hidden imgbox_wid6 bg-neutral-dark text-center font-weight-bold text-black-50 d-flex justify-content-center align-items-center"></div>
                                    )}
                                  </div>

                                  <div className="rounded-circle avatar-image overflow-hidden imgbox_wid7 text-center font-weight-bold text-success d-flex justify-content-center align-items-center up_file">
                                    <LazyLoadedImage
                                      className="img-fluid img-fit-container rounded-circle profile_img"
                                      src={
                                        existImage
                                          ? custImageValue
                                          : changedImage
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5>
                            <span className="text-danger">&#42;</span> First
                            Name
                          </h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInput ? (
                          <h3 className="usenameedit">
                            {userDetails["first_name"]}
                          </h3>
                        ) : (
                          <Input
                            required
                            className="form-control"
                            id="firstname"
                            invalid={
                              (fNameError ? true : false) ||
                              (fNameError ? true : false)
                            }
                            valid={userDetails["first_name"] ? true : false}
                            disabled={false}
                            placeholder="First Name"
                            type="text"
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                first_name: e.target.value.trim(),
                              });
                              if (e.target.value?.length > 0) {
                                setfNameError(false);
                                if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                                  setfNameTextError(false);
                                } else {
                                  setfNameTextError(true);
                                }
                              } else {
                                setfNameError(true);
                              }
                            }}
                            value={userDetails["first_name"]}
                            onBlur={(e) => {
                              if (e.target.value?.length > 0) {
                                setfNameError(false);
                                if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                                  setfNameTextError(false);
                                } else {
                                  setfNameTextError(true);
                                }
                              } else {
                                setfNameError(true);
                              }
                            }}
                          />
                        )}
                        {fNameError && (
                          <p style={{ color: "red" }}>
                            First name cannot be empty
                          </p>
                        )}
                        {fNameTextError && (
                          <p style={{ color: "red" }}>
                            First name should be text only
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5>
                            <span className="text-danger">&#42;</span> Last Name
                          </h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputlastname ? (
                          <h3 className="usenameedit">
                            {userDetails["last_name"]}
                          </h3>
                        ) : (
                          <Input
                            required
                            className="form-control"
                            id="latname"
                            invalid={
                              (lnameError ? true : false) ||
                              (lnameError ? true : false)
                            }
                            valid={userDetails["last_name"] ? true : false}
                            disabled={false}
                            placeholder="Last Name"
                            type="text"
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                last_name: e.target.value.trim(),
                              });
                              if (e.target.value?.length > 0) {
                                setLNameError(false);
                                if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                                  setLNameTextError(false);
                                } else {
                                  setLNameTextError(true);
                                }
                              } else {
                                setLNameError(true);
                              }
                            }}
                            value={userDetails["last_name"]}
                            onBlur={(e) => {
                              if (e.target.value?.length > 0) {
                                setLNameError(false);
                                if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                                  setLNameTextError(false);
                                } else {
                                  setLNameTextError(true);
                                }
                              } else {
                                setLNameError(true);
                              }
                            }}
                          />
                        )}
                        {lnameError && (
                          <p style={{ color: "red" }}>
                            Last name cannot be empty
                          </p>
                        )}
                        {lNameTextError && (
                          <p style={{ color: "red" }}>
                            Last name should be text only
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">Email</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputemail ? (
                          <h3 className="usenameedit">
                            {userDetails["email"]}
                          </h3>
                        ) : (
                          <Input
                            className="form-control"
                            id="email"
                            disabled={true}
                            placeholder="email"
                            type="email"
                            value={userDetails["email"]}
                          />
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5>
                            <span className="text-danger">&#42;</span> Whatsapp
                            Number
                          </h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputphone ? (
                          <h3 className="usenameedit">
                            {userDetails["phone"] || ""}
                          </h3>
                        ) : (
                          <Input
                            required
                            className="form-control"
                            id="mobileNumberInput"
                            disabled={false}
                            placeholder="whatsapp number"
                            type="number"
                            value={userDetails["phone"] || ""}
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                phone: e.target.value,
                              });
                              if (e.target.value) {
                                setPhoneError(false);
                              } else {
                                setPhoneError(true);
                              }
                            }}
                          />
                        )}
                        {phoneError && (
                          <p style={{ color: "red" }}>
                            Please enter your number
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">GST</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        <Input
                          className="form-control"
                          id="gstnumberinput"
                          disabled={false}
                          placeholder="enter GST number"
                          type="text"
                          value={userDetails["gst"] || ""}
                          onChange={(e) => {
                            setUserDetails({
                              ...userDetails,
                              gst: e.target.value,
                            });
                            if (e.target.value) {
                              setGstError(false);
                            } else {
                              setGstError(true);
                            }
                          }}
                        />
                        {gstError && (
                          <p style={{ color: "red" }}>
                            Please enter your GST number
                          </p>
                        )}
                      </div>

                      <div className="col-sm-1">
                        <button
                          className="edit_form"
                          onClick={() => gstValidateClickHandler()}
                        >
                          {gstValidateText}
                        </button>
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">Business Name</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputbus ? (
                          <h3 className="usenameedit">
                            {userDetails["business_name"]}
                          </h3>
                        ) : (
                          <Input
                            className="form-control"
                            id="businessname"
                            disabled={false}
                            placeholder="Shop no, Area, Locality"
                            type="text"
                            value={userDetails["business_name"]}
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                business_name: e.target.value.trim(),
                              });
                              if (e.target.value) {
                                setBusinessNameError(false);
                              } else {
                                setBusinessNameError(true);
                              }
                            }}
                          />
                        )}

                        {businessNameError && (
                          <p style={{ color: "red" }}>
                            Please enter your business name
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">City</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputCity ? (
                          <h3 className="usenameedit">{userDetails["city"]}</h3>
                        ) : (
                          <Input
                            className="form-control"
                            id="city"
                            disabled={false}
                            placeholder="City"
                            type="text"
                            value={userDetails["city"]}
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                city: e.target.value.trim(),
                              });
                            }}
                            autoComplete="off"
                          />
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">State</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputState ? (
                          <h3 className="usenameedit">
                            {userDetails["state"]}
                          </h3>
                        ) : (
                          <Input
                            className="form-control"
                            id="state"
                            disabled={false}
                            placeholder="State"
                            type="text"
                            value={userDetails["state"]}
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                state: e.target.value.trim(),
                              });
                            }}
                            autoComplete="off"
                          />
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">Country</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputCountry ? (
                          <h3 className="usenameedit">
                            {userDetails["country"]}
                          </h3>
                        ) : (
                          <Input
                            className="form-control"
                            id="country"
                            disabled={false}
                            placeholder="Country"
                            type="text"
                            value={userDetails["country"]}
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                country: e.target.value.trim(),
                              });
                            }}
                            autoComplete="off"
                          />
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">Address Line 1</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputaddress1 ? (
                          <h3 className="usenameedit">
                            {userDetails["address1"]}
                          </h3>
                        ) : (
                          <Input
                            className="form-control"
                            id="address1"
                            disabled={false}
                            placeholder="Shop no, Area, Locality"
                            type="text"
                            value={userDetails["address1"]}
                            onChange={(e) => {
                              setUserDetails({
                                ...userDetails,
                                address1: e.target.value.trim(),
                              });
                            }}
                            autoComplete="off"
                          />
                        )}
                      </div>
                    </div>

                    <div className="row row_cen2">
                      <div className="col-sm-3">
                        <div className="profile_label">
                          <h5 className="not_validate">Address Line 2</h5>
                        </div>
                      </div>

                      <div className="col-sm-8">
                        {!showInputaddress2 ? (
                          <h3 className="usenameedit">
                            {userDetails["address2"]}
                          </h3>
                        ) : (
                          <form onSubmit={(e) => e.preventDefault()}>
                            <input
                              className="form-control"
                              id="address2"
                              disabled={false}
                              placeholder="City, State"
                              type="text"
                              value={userDetails["address2"]}
                              onChange={(e) => {
                                setUserDetails({
                                  ...userDetails,
                                  address2: e.target.value.trim(),
                                });
                              }}
                              autoComplete={false}
                              auto
                            />
                          </form>
                        )}
                      </div>
                    </div>
                  </div>

                  <SubscriptionEdit list={list} getHistory={getHistory} />
                </div>
              </div>
            </div>
          </div>

          <UserBillingHistory planDetails={planDetails} />
        </div>
      </section>
    </div>
  );
}
